import SubscriptionComponent from "./subscriptionComponent";

export default SubscriptionComponent;
